module.exports = __webpack_public_path__ + "img/leadConfirmed.1f3fb89f.svg";